import React, { useState } from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const EmailSender = () => {
  const [recipientsInput, setRecipientsInput] = useState('');
  const [subject, setSubject] = useState('');
  const [editorContent, setEditorContent] = useState('');
  const [status, setStatus] = useState('');
  const [csvContacts, setCsvContacts] = useState([]);
  const [storedContacts, setStoredContacts] = useState([]);
  const [emailResults, setEmailResults] = useState([]);

  // Function to fetch stored contacts
  const fetchContacts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_URLVAR}/api/event/fetchcontacts`, {
        headers: { 'x-auth-token': token }
      });
      setStoredContacts(response.data.contacts);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  // Function to add selected contacts to "Additional Recipients"
  const addContactsToRecipients = () => {
    const formattedContacts = storedContacts.map(contact => `${contact.name} <${contact.email}>`).join(', ');
    setRecipientsInput(prev => prev ? `${prev}, ${formattedContacts}` : formattedContacts);
  };

  // Function to handle CSV file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        complete: function (results) {
          const extractedData = results.data
            .filter(row => row.name && row.email)
            .map(row => ({
              name: row.name.trim(),
              email: row.email.trim()
            }));
          setCsvContacts(extractedData);
        }
      });
    }
  };

  // Function to parse manually entered names and emails
  const parseManualEntries = (input) => {
    return input.split(',').map(entry => {
      const match = entry.match(/(.+)\s*<(.+)>/);
      if (match) {
        return { name: match[1].trim(), email: match[2].trim() };
      }
      return { name: '', email: entry.trim() };
    }).filter(entry => entry.email);
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const manualContacts = parseManualEntries(recipientsInput);
    const finalContacts = [...csvContacts, ...manualContacts];

    const emailData = {
      contacts: finalContacts,
      subject,
      html: editorContent,
    };

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${process.env.REACT_APP_URLVAR}/api/event/send-emails`, emailData, {
        headers: { 'x-auth-token': token }
      });

      setStatus('Emails sent successfully!');
      setEmailResults(response.data.results);
      const myModal = new window.bootstrap.Modal(
        document.getElementById("emailResultsModal")
      );
      myModal.show();
    } catch (error) {
      setStatus('Error sending emails.');
      console.error(error);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4 about-heading">Send Personalized Emails</h2>
      <form onSubmit={handleSubmit} className='shadow-lg p-4 border-1 border rounded-4'>
        <div className="mb-3">
          <label className="form-label">Upload CSV File with Emails:</label>
          <input type="file" className="form-control" accept=".csv" onChange={handleFileUpload} />
        </div>

        <div className="mb-3">
          <label className="form-label">Additional Recipients:</label>
          <input
            type="text"
            className="form-control"
            value={recipientsInput}
            onChange={(e) => setRecipientsInput(e.target.value)}
            placeholder='Enter name and email (e.g., John Doe <john@example.com>)'
          />
        </div>

        <button type="button" className="btn btn-custom-primary me-2" onClick={fetchContacts}>Fetch Stored Contacts</button>
        <button type="button" className="btn btn-custom-outline-primary me-2" onClick={addContactsToRecipients}>Add Fetched Contacts</button>

     {/* Display fetched contacts */}
     {storedContacts.length > 0 && (
          <div className="mt-3">
            <h5>Stored Contacts:</h5>
            <ul className="list-group">
              {storedContacts.map((contact, index) => (
                <li key={index} className="list-group-item">
                  {contact.name} ({contact.email})
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mb-3 mt-3">
          <label className="form-label">Subject:</label>
          <input type="text" className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Email Content:</label>
          <p className='text-small'>Enter {`{{name}}`} where you have to enter recipient name</p>
          <CKEditor
            editor={ClassicEditor}
            data={editorContent}
            onChange={(event, editor) => setEditorContent(editor.getData())}
          />
        </div>

        <button type="submit" className="btn btn-custom-primary">Send Emails</button>
      </form>
      {/* Bootstrap Modal */}
    <div
        className="modal fade"
        id="emailResultsModal"
        tabIndex="-1"
        aria-labelledby="emailResultsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="emailResultsModalLabel">
                Email Sent Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {emailResults.length > 0 ? (
                <ul className="list-group">
                  {emailResults.map((result, index) => (
                    <li key={index} className="list-group-item">
                      {result.email}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No emails were sent.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-custom-outline-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSender;